/** Boje za stream boksove kad nije postavljena u Strapi */
const STREAM_COLORS = [
  '#3b82f6', '#ec4899', '#8b5cf6', '#06b6d4', '#f59e0b',
  '#10b981', '#ef4444', '#6366f1', '#14b8a6', '#f97316',
];

/**
 * Vraća CSS background value — može biti hex (npr. "#3b82f6") ili gradient string
 * (npr. "linear-gradient(135deg, #D946EF 0%, ...)").
 *
 * Iz Strapi-ja `color` polje može biti:
 *   - hex (#RRGGBB)
 *   - linear-gradient(...)
 *   - radial-gradient(...)
 *   - prazno → fallback na hash od imena
 */
export function getStreamColor(color?: string, name?: string): string {
  if (color) {
    const c = color.trim();
    if (/^#[0-9A-Fa-f]{6}$/.test(c)) return c;
    if (c.startsWith('linear-gradient(') || c.startsWith('radial-gradient(') || c.startsWith('conic-gradient(')) {
      return c;
    }
  }
  if (!name) return STREAM_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const idx = Math.abs(hash) % STREAM_COLORS.length;
  return STREAM_COLORS[idx];
}

/**
 * Vraća true ako je vrijednost CSS gradient (ne solid hex).
 * Korisno za grananje između `background` i `backgroundColor`.
 */
export function isGradient(value: string): boolean {
  return /^(linear|radial|conic)-gradient\(/.test(value.trim());
}

/**
 * Iz CSS gradient stringa izvlači središnju hex boju za situacije
 * gdje gradient nije podržan (border, ring, glow, text color).
 * Za solid hex jednostavno vraća isti string.
 */
export function getSolidColor(value: string): string {
  if (!isGradient(value)) return value;
  const matches = value.match(/#[0-9A-Fa-f]{6}/g);
  if (!matches || matches.length === 0) return STREAM_COLORS[0];
  const middle = Math.floor(matches.length / 2);
  return matches[middle];
}
